import type { Chart } from 'chart.js'

export interface ChartTooltipData {
  // Financial data from your existing tooltip handlers
  year?: string
  milestone?: string
  goal?: string
  ages?: Record<string, number>
  netWealth?: number
  super?: number
  assets?: number
  debts?: number
  // Engagement data for doughnut charts
  percentage?: number
  activeMembers?: number
  adviceIssued?: number
  moduleLabel?: string
}

export interface ChartDataPoint {
  index: number
  label: string // x-axis value (year, category, etc.)
  values: Record<string, any> // dataset values by dataset name
  tooltip?: ChartTooltipData
}

export interface ChartContext {
  chartTitle?: string
  currentAge?: number
  retirementAge?: number
  timeframe?: string
  calculationType?: string
  userMetadata?: any
  chartDescription?: string
}

export interface ChartExplanationData {
  // Visual representation
  image: string // base64 PNG

  // Chart metadata
  type: 'line' | 'bar' | 'doughnut' | 'pie'
  title?: string
  xAxisLabel?: string
  yAxisLabel?: string

  // Structured data for each point
  dataPoints: ChartDataPoint[]

  // User/chart context
  context: ChartContext

  // Raw chart data for reference
  chartData?: {
    labels: any[]
    datasets: any[]
  }
}

export interface ChartExplanationOptions {
  includeTooltips?: boolean
  includeRawData?: boolean
  context?: ChartContext
  waitForAnimation?: boolean
}

export interface ChartExplanationResponse {
  explanation: string
  insights?: string[]
  recommendations?: string[]
}

// Type guard for Chart.js instances
export function isChart(obj: any): obj is Chart {
  return obj && typeof obj.toBase64Image === 'function' && obj.data && obj.config
}
